import { library, dom } from "@fortawesome/fontawesome-svg-core"

import { faGithub, faXTwitter, faLinkedin } from "@fortawesome/free-brands-svg-icons"

import {
  faAlarmClock,
  faArchive,
  faArrowRightFromBracket,
  faArrowsRotate,
  faBars,
  faBell,
  faBracketsCurly,
  faCalendarAlt,
  faCalendarArrowDown,
  faCalendarDay,
  faChartLine,
  faChartMixed,
  faCheck,
  faChevronDown,
  faChevronsLeft,
  faChevronLeft,
  faChevronRight,
  faChevronsRight,
  faCircleQuestion,
  faClipboard,
  faMobile,
  faClock,
  faClone,
  faCogs,
  faCompress,
  faCopy,
  faCreditCard,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExternalLink,
  faEye,
  faEyeSlash,
  faFilter,
  faFolderOpen,
  faGift,
  faHome,
  faKey,
  faKeyboard,
  faList,
  faPaperPlane,
  faPen,
  faPlus,
  faReceipt,
  faRocket,
  faSave,
  faSearch,
  faSignOutAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faTag,
  faTags,
  faTrash,
  faUser,
  faUserCircle,
  faUserClock,
  faUserShield,
  faUserTie,
  faUsers,
  faWandMagicSparkles,
  faXmark,
} from "@fortawesome/pro-light-svg-icons"

// Brands icons
library.add(faGithub, faXTwitter, faLinkedin)

// Regular icons
library.add(
  faAlarmClock,
  faArchive,
  faArrowRightFromBracket,
  faArrowsRotate,
  faBars,
  faBell,
  faBracketsCurly,
  faCalendarAlt,
  faCalendarArrowDown,
  faCalendarDay,
  faChartLine,
  faChartMixed,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronsLeft,
  faChevronRight,
  faChevronsRight,
  faMobile,
  faCircleQuestion,
  faClipboard,
  faClock,
  faClone,
  faCogs,
  faCompress,
  faCopy,
  faCreditCard,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExternalLink,
  faEye,
  faEyeSlash,
  faFilter,
  faFolderOpen,
  faGift,
  faHome,
  faKey,
  faKeyboard,
  faList,
  faPaperPlane,
  faPen,
  faPlus,
  faReceipt,
  faRocket,
  faSave,
  faSearch,
  faSignOutAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faTag,
  faTags,
  faTrash,
  faUser,
  faUserCircle,
  faUserClock,
  faUserShield,
  faUserTie,
  faUsers,
  faWandMagicSparkles,
  faXmark,
)

document.addEventListener("turbo:load", () => {
  // Replace any existing <i> tags with <svg> and set up a MutationObserver to
  // continue doing this as the DOM changes.
  dom.watch()
})
